import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';
import { Exclusions, ListingExclusions } from './types/Listing';

export default (makeCall: MakeCall) => (
  listingId: number,
  exclusions: Exclusions[] = [],
  adjustDates: boolean = true,
) =>
  makeCall<ListingExclusions>(
    'POST',
    `${APIV2_URL}/listing/${listingId}/exclusions`,
    {
      data: exclusions,
      query: { adjustDates },
    },
  );
